import { resolveByEnv } from '@/app/resolve-by-env'

const AUTH0_DOMAIN_MAP = {
  development: 'login.tractian.dev',
  production: 'login.tractian.com'
} as const

const AUTH0_CLIENT_ID_MAP = {
  development: '7gljh2vm4QolXGF26NA5m8iJiUTTLGqJ',
  production: 'mRZG1evagZEVKscfXMsVTY1t4287lKV2'
} as const

const AUTH0_AUDIENCE_MAP = {
  development: 'https://api.tractian.dev',
  production: 'https://api.tractian.com'
} as const

// `vite --mode prod` (just web-v2 prod) points the base URLs at the caddy proxy
// → prod backends, but runs on localhost so getEnv() would classify it as
// development. A dev-tenant Auth0 token (audience api.tractian.dev) is rejected
// by prod backends → 401 on every call. When MODE === 'prod', force the prod
// Auth0 values so the tenant matches the backends the proxy is hitting. Real
// prod deploys (MODE === 'production') still resolve by hostname, which
// classifies the prod host as production anyway.
const isLocalProdMode = import.meta.env.MODE === 'prod'

export const getAuth0Domain = () =>
  isLocalProdMode ? AUTH0_DOMAIN_MAP.production : resolveByEnv(AUTH0_DOMAIN_MAP)

export const getAuth0ClientId = () =>
  isLocalProdMode
    ? AUTH0_CLIENT_ID_MAP.production
    : resolveByEnv(AUTH0_CLIENT_ID_MAP)

export const getAuth0Audience = () =>
  isLocalProdMode
    ? AUTH0_AUDIENCE_MAP.production
    : resolveByEnv(AUTH0_AUDIENCE_MAP)

export const getAuth0CookieDomain = (): string | undefined => {
  const hostname = window.location.hostname
  if (hostname.endsWith('.tractian.com')) return '.tractian.com'
  if (hostname.endsWith('.tractian.dev')) return '.tractian.dev'
  return undefined
}
